export default __webpack_public_path__ + "static/media/151-garden-work.3c641f40.png";